import { Controller } from '@hotwired/stimulus'

const STORAGE_KEY = 'sale-banner-dismissed-until'
const DISMISS_DURATION = 2 * 60 * 60 * 1000

export default class extends Controller {
  connect() {
    if (Number(localStorage.getItem(STORAGE_KEY)) > Date.now()) return

    this.element.classList.remove('hidden')
  }

  dismiss() {
    localStorage.setItem(STORAGE_KEY, String(Date.now() + DISMISS_DURATION))
    this.element.remove()
  }
}
